var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButtonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 17.1,
    height: 17.1,
    rx: 8.55,
    fill: "#006580"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 17.1,
    height: 17.1,
    rx: 8.55,
    stroke: "#006580",
    strokeWidth: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.40039,
    y: 5.3999,
    width: 7.2,
    height: 7.2,
    rx: 3.6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonFilled);
export default __webpack_public_path__ + "static/media/radioButtonFilled.719bb63fe51b5c3c68ad669fe08881a7.svg";
export { ForwardRef as ReactComponent };